<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input" (onActivateLink)="onActivateLink.emit()">
    <div class="text-area-field">
        <textarea #input class="text-area-field-input" [attr.id]="inputId()"
                  [value]="displayValue()" (input)="handleInputEvent($event)"
                  [attr.maxlength]="maxLength()" [attr.spellcheck]="spellCheck()" [readOnly]="readOnly()"
                  [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()"></textarea>
        @if (!valueSignal()) {
            <div class="text-area-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
</woa-field>
